(function () {
  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      cartItems.onCartUpdate();
    } else {
      window.location.reload();
    }
  }

  function changeLine(line, sellingPlan) {
    var body = { line: line };
    body.selling_plan = sellingPlan || null;
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/change.js'
      : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json();
    });
  }

  function handleFrequencyChange(event) {
    var select = event.target;
    var container = select.closest('[data-subscription-line-controls]');
    if (!container) return;
    var line = container.getAttribute('data-line');
    changeLine(line, select.value).then(refreshCartUI);
  }

  function handleOneTimeSwitch(event) {
    var btn = event.target;
    var container = btn.closest('[data-subscription-line-controls]');
    if (!container) return;
    var line = container.getAttribute('data-line');
    btn.disabled = true;
    changeLine(line, null).then(refreshCartUI);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.hasAttribute('data-subscription-frequency-select')) {
      handleFrequencyChange(event);
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.hasAttribute('data-switch-to-one-time')) {
      handleOneTimeSwitch(event);
    }
  });
})();
